<template>
  <div>
    <vx-card title="Variables / Modelo verificación perfil instalador">
      <vs-table :data="[{}]">
        <vs-tr>
          <vs-td>Antigüedad de operación</vs-td>
          <vs-td>{{form.operation_age}}</vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td>Antigüedad de tecnología</vs-td>
          <vs-td>{{form.technology_age}}</vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td>Ingeniería</vs-td>
          <vs-td>{{form.engineering}}</vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td>Capacidad Instalada</vs-td>
          <vs-td>{{form.installed_capacity}}</vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td>Cantidad de cuadrillas</vs-td>
          <vs-td>{{form.team_work_quantity}}</vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td>Alerta PLD</vs-td>
          <vs-td>{{form.has_pld_alert}}</vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td>Saldo vencido</vs-td>
          <vs-td>{{form.due_balance}}</vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td>Testimonios y referencias</vs-td>
          <vs-td>{{form.testimonies_references|fixNumber}}</vs-td>
        </vs-tr>
      </vs-table>

      <vs-button class="mt-10 float-right" @click="$emit('onSubmit', form)">
        Verificación de perfil SFV
      </vs-button>

    </vx-card>
  </div>
</template>

<script>
import {fixNumber} from "@/filters/NumberFilters";

export default {
  name: "SupplierRiskModelProfileVerificationForm",
  props: {
    familyGroupId: {
      type: Number,
      required: true
    },
    supplierId: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    form: {}
  }),
  filters: {
    fixNumber
  },
  async mounted() {
    try {
      let response = await axios.get(`/api/risk-model/sid/${this.supplierId}/profile-verification-sfv/form?family_group_id=${this.familyGroupId}`)
      this.form = response.data;
    } catch (e) {

    }
  }
}
</script>

<style scoped>

</style>
